"use client";
import { useState } from 'react';
import Image from 'next/image';
import { industries } from "@/lib/content";

const Industries = () => {
  const [isPaused, setIsPaused] = useState(false);

  // We duplicate the cards array once for a seamless loop
  const displayCards = [...industries.industriesCards, ...industries.industriesCards];

  return (
    <section className="py-8 md:py-20 bg-white overflow-hidden" aria-labelledby="industries-title">
      {/* Scope keyframes to this component */}
      <style jsx>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-content {
          display: flex;
          width: max-content;
          animation: scroll 40s linear infinite;
        }
        .paused {
          animation-play-state: paused;
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-content {
            animation: none;
            flex-wrap: wrap;
            justify-content: center;
          }
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 id="industries-title" className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">
            {industries.title}
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            {industries.description}
          </p>
        </div>

        <div 
          className="relative group"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          // Accessibility: Pause when a keyboard user tabs in
          onFocus={() => setIsPaused(true)}
          onBlur={() => setIsPaused(false)}
        >
          {/* Gradient Overlays - Purely Visual */}
          <div className="absolute left-0 top-0 h-full w-0 md:w-20 z-10 bg-gradient-to-r from-white via-white/80 to-transparent pointer-events-none" aria-hidden="true" />
          <div className="absolute right-0 top-0 h-full w-0 md:w-20 z-10 bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none" aria-hidden="true" />

          {/* Marquee Container */}
          <div className="overflow-hidden py-4">
            <div className={`marquee-content ${isPaused ? 'paused' : ''}`}>
              {displayCards.map((industry, index) => (
                <article
                  key={`${industry.title}-${index}`}
                  className="flex-shrink-0 w-[320px] mx-4 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl hover:border-blue-100 transition-all duration-500 group/card"
                >
                  <div className="relative h-48 w-full overflow-hidden rounded-t-2xl">
                    <Image
                      src={industry.imageUrl}
                      alt="" // Decorative since the title is below
                      fill
                      className="object-cover transform group-hover/card:scale-110 transition-transform duration-700"
                      sizes="320px"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover/card:text-[#4F7AC2] transition-colors">
                      {industry.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed line-clamp-3">
                      {industry.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;